import { render, staticRenderFns } from "./CommTextModal.vue?vue&type=template&id=de607c2a&scoped=true&"
import script from "./CommTextModal.vue?vue&type=script&lang=js&"
export * from "./CommTextModal.vue?vue&type=script&lang=js&"
import style0 from "./CommTextModal.vue?vue&type=style&index=0&id=de607c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de607c2a",
  null
  
)

export default component.exports